import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { configureBorgeeTransport } from './client-core/transport';
import { createWebTransport } from './hosts/web/transport';
import { getDevUserId } from './lib/api';

configureBorgeeTransport(
  createWebTransport({ getDevUserId, isDevelopment: import.meta.env.DEV }),
);

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js');
  });
}
